const runLegacyApp = () => {
  // reference jquery in html templates
  // global.$ = global.jQuery = require('jquery');

  // Nav open

  $(".js-menu").click(function(evt) {
    evt.preventDefault();
    $(".nav").toggleClass("show");
    $("body").toggleClass("overflow");
  });

  // Accordion

  $(".accordion--item .accordion--header").click(function() {
    $(this)
      .parent()
      .toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active");
  });

  // Expand all

  $(".expand-all--link").click(function() {
    $(".accordion--item").addClass("active");
    $(".collapse-all--link").show();
    $(".expand-all--link").hide();
  });

  $(".collapse-all--link").click(function() {
    $(".accordion--item").removeClass("active");
    $(".collapse-all--link").hide();
    $(".expand-all--link").show();
  });

  // Mobile accordion sidebar

  document.addEventListener('DOMContentLoaded', function() {
    var dropdownToggle = document.getElementById('dropdown-toggle');
    var dropdownContent = document.getElementById('dropdown-content');
    
    // Define the media query (adjust max-width according to your $md breakpoint)
    var mediaQuery = window.matchMedia('(max-width: 992px)'); // Example: $md = 768px

    function handleDropdown() {
        if (dropdownToggle && dropdownContent){
          // Only add the event listener if the screen is within the $md breakpoint and below
          if (mediaQuery.matches) {
              dropdownToggle.addEventListener('click', toggleDropdown);
          } else {
              // Remove event listener if the screen is larger than $md
              dropdownToggle.removeEventListener('click', toggleDropdown);
          }
        }
    }

    function toggleDropdown(e) {
        e.preventDefault();
        dropdownContent.classList.toggle('open');
        dropdownToggle.classList.toggle('open');
    }

    // Check on load
    handleDropdown();

    // Check if the screen is resized and adjust
    mediaQuery.addEventListener('change', handleDropdown);
  });


  // Sticky Header

  $(function() {
      $(window).scroll(function() {
          if ($(window).scrollTop() >= 200) {
            $(".sticky-header").addClass("fixed slideDown");
          } else {
            $(".sticky-header").removeClass("fixed slideInDown");
          }
        
      });
  });

  // Video Modal

  $(".play-button").click(function(e) {
      e.preventDefault();
      const videoUrl = $(this).attr("data-src");
      $("body").addClass('body--no-scroll');
      
      $(".video-iframe").attr("src", videoUrl);
      $("#bkgOverlay").fadeIn(400);
      $("#delayedPopup").fadeIn(400);
      $(".loading-icon").show();

      $(".video-iframe").on("load", function() {
        $(".loading-icon").hide();
      });
  });

  $(".modal-close").click(function() {
    $("body").removeClass('body--no-scroll');
    $("#bkgOverlay").fadeOut();
    $("#delayedPopup").fadeOut();
    $(".video-iframe").attr("src", "");
  });

  // Gallery

  $(".gallery-tab").click(function(event) {
    $(this).addClass("active");
    $(this)
      .siblings()
      .removeClass("active");

    var selectedval = $(this).data("href");

    var selectedgallery = $("#" + selectedval);

    $(selectedgallery).addClass("active");
    $(selectedgallery)
      .siblings()
      .removeClass("active");
  });

  // Conservatory Content Swapper

  $(".conservatory-tab").click(function(event) {
    $(this).addClass("active");
    $(this)
      .siblings()
      .removeClass("active");

    var selectedval = $(this).data("href");
    var selectedconservatory = $("#" + selectedval);

    $(selectedconservatory).addClass("active");
    $(selectedconservatory)
      .siblings()
      .removeClass("active");
  });

  // Range

  let currentRangeSlideIndex = 0;
  const slides = $(".range-content--inner");
  const prevArrow = $(".prev-arrow");
  const nextArrow = $(".next-arrow");

  function updateSlide(index) {
    // Update active slide
    slides.removeClass("active").eq(index).addClass("active");
    $(".range-tab").removeClass("active").eq(index).addClass("active");

    // Disable arrows if at the beginning or end
    if (index === 0) {
      prevArrow.attr("disabled", true).addClass("disabled");
    } else {
      prevArrow.attr("disabled", false).removeClass("disabled");
    }

    if (index === slides.length - 1) {
      nextArrow.attr("disabled", true).addClass("disabled");
    } else {
      nextArrow.attr("disabled", false).removeClass("disabled");
    }
  }

  // Initial state
  updateSlide(currentRangeSlideIndex);

  // Arrow click events
  nextArrow.click(function() {
    if (currentRangeSlideIndex < slides.length - 1) {
      currentRangeSlideIndex++;
      updateSlide(currentRangeSlideIndex);
    }
  });

  prevArrow.click(function() {
    if (currentRangeSlideIndex > 0) {
      currentRangeSlideIndex--;
      updateSlide(currentRangeSlideIndex);
    }
  });

  $(".swatch-thumbnail").click(function(event) {
    var main_image = $(this).attr("data-main-image");
    var selectedswatch = $(this).attr("src");
    $("." + main_image + " img").attr("src", selectedswatch);
  });

  // Thumbnail click event (optional, for sync with swatches)
  $(".range-tab").click(function(event) {
    currentRangeSlideIndex = $(this).index();
    updateSlide(currentRangeSlideIndex);
  });


  // Contact Map
  var allStates = $("svg.uk path");

  allStates.on("click", function() {
    allStates.removeClass("active");
    $(this).addClass("active");
    var area = $(this).attr("data-area");

    $(".area-info").removeClass("active");
    document.getElementById(area).classList.add("active");
  });

  // custom form validation

  // (function() {
  // 	let errors;

  // 	if (errors.length >= 1) {
  // 		// convert nodelist to array
  // 		errors = Array.prototype.slice.call(errors);

  // 		// for each error list
  // 		errors.forEach(error => {
  // 			let message = error.previousSibling.getAttribute("data-error");
  // 			error.firstChild.textContent = message;
  // 		});
  // 	}
  // })();

  // Comparison Slider
  // $(function() {
  //   var beforelabel = $(this)
  //     .find(".slider-before--img")
  //     .attr("data-caption");
  //   var afterlabel = $(this)
  //     .find(".slider-after--img")
  //     .attr("data-caption");

  //   $(".comparison-slider--inner").twentytwenty({
  //     before_label: beforelabel,
  //     after_label: afterlabel
  //   });
  // });

  // $(function() {
  //   var beforelabel = $(this)
  //     .find(".slider-before--img")
  //     .attr("data-caption");
  //   var afterlabel = $(this)
  //     .find(".slider-after--img")
  //     .attr("data-caption");

  //   $(".comparison-slider--global").twentytwenty({
  //     before_label: beforelabel,
  //     after_label: afterlabel
  //   });
  // });

  // $(".slider-tab").click(function(event) {
  //   $(this).addClass("active");
  //   $(this)
  //     .siblings()
  //     .removeClass("active");

  //   var selectedval = $(this).data("href");
  //   var selectedslide = $("#" + selectedval);

  //   $(selectedslide).addClass("active");
  //   $(selectedslide)
  //     .siblings()
  //     .removeClass("active");

  //   $(function() {
  //     var beforelabel = $(this)
  //       .find(".slider-before--img")
  //       .attr("data-caption");
  //     var afterlabel = $(this)
  //       .find(".slider-after--img")
  //       .attr("data-caption");

  //     $(".comparison-slider--inner").twentytwenty({
  //       before_label: beforelabel,
  //       after_label: afterlabel
  //     });
  //   });

  // comparisonInit();
  // });



  /*
  It is using jquery UI because that chris coyier function doesn't work on touch
  but you also need to add this public / js / jquery.mobile.custom.min.js
  which has a dependency  public / js / jquery.event.move.js
  */
  $(function() {
    var beforelabel = $(this)
      .find(".slider-before--img")
      .attr("data-caption");
    var afterlabel = $(this)
      .find(".slider-after--img")
      .attr("data-caption");

    // { # $(".comparison-slider--inner").twentytwenty({ before_label: beforelabel, after_label: afterlabel }); # }
  });

  $(function() {
    var beforelabel = $(this)
      .find(".slider-before--img")
      .attr("data-caption");
    var afterlabel = $(this)
      .find(".slider-after--img")
      .attr("data-caption");

    // { # $(".comparison-slider--global").twentytwenty({ before_label: beforelabel, after_label: afterlabel }); # }
  });

  $(".slider-tab").click(function(event) {
    $(this).addClass("active");
    $(this)
      .siblings()
      .removeClass("active");

    var selectedval = $(this).data("href");
    var selectedslide = $("#" + selectedval);

    $(selectedslide).addClass("active");
    $(selectedslide)
      .siblings()
      .removeClass("active");

    $(function() {
      var beforelabel = $(this)
        .find(".slider-before--img")
        .attr("data-caption");
      var afterlabel = $(this)
        .find(".slider-after--img")
        .attr("data-caption");

      // { # $(".comparison-slider--inner").twentytwenty({ before_label: beforelabel, after_label: afterlabel }); # }
    });
  });

  jQuery(document).ready(function($) {
    var dragging = false,
      scrolling = false,
      resizing = false;
    //cache jQuery objects
    var imageComparisonContainers = $(".cd-image-container");
    //check if the .cd-image-container is in the viewport
    //if yes, animate it
    checkPosition(imageComparisonContainers);
    $(window).on("scroll", function() {
      if (!scrolling) {
        scrolling = true;
        !window.requestAnimationFrame
          ? setTimeout(function() {
              checkPosition(imageComparisonContainers);
            }, 100)
          : requestAnimationFrame(function() {
              checkPosition(imageComparisonContainers);
            });
      }
    });

    //make the .cd-handle element draggable and modify .cd-resize-img width according to its position
    imageComparisonContainers.each(function() {
      var actual = $(this);
      drags(
        actual.find(".cd-handle"),
        actual.find(".cd-resize-img"),
        actual,
        actual.find('.cd-image-label[data-type="original"]'),
        actual.find('.cd-image-label[data-type="modified"]')
      );
    });

    $(".cd-image-container").each(function() {
      var actual = $(this);
      drags(actual.find(".cd-handle"), actual.find(".cd-resize-img"), actual);
    });

    //upadate images label visibility
    $(window).on("resize", function() {
      if (!resizing) {
        resizing = true;
        !window.requestAnimationFrame
          ? setTimeout(function() {
              checkLabel(imageComparisonContainers);
            }, 100)
          : requestAnimationFrame(function() {
              checkLabel(imageComparisonContainers);
            });
      }
    });

    function checkPosition(container) {
      container.each(function() {
        var actualContainer = $(this);
        if (
          $(window).scrollTop() + $(window).height() * 0.5 >
          actualContainer.offset().top
        ) {
          actualContainer.addClass("is-visible");
        }
      });

      scrolling = false;
    }

    function checkLabel(container) {
      container.each(function() {
        var actual = $(this);
        updateLabel(
          actual.find('.cd-image-label[data-type="modified"]'),
          actual.find(".cd-resize-img"),
          "left"
        );
        updateLabel(
          actual.find('.cd-image-label[data-type="original"]'),
          actual.find(".cd-resize-img"),
          "right"
        );
      });

      resizing = false;
    }

    //draggable funtionality - credits to http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/
    function drags(
      dragElement,
      resizeElement,
      container,
      labelContainer,
      labelResizeElement
    ) {
      dragElement
        .on("mousedown vmousedown", function(e) {
          dragElement.addClass("draggable");
          resizeElement.addClass("resizable");

          var dragWidth = dragElement.outerWidth(),
            xPosition = dragElement.offset().left + dragWidth - e.pageX,
            containerOffset = container.offset().left,
            containerWidth = container.outerWidth(),
            minLeft = containerOffset + 10,
            maxLeft = containerOffset + containerWidth - dragWidth - 10;

          dragElement
            .parents()
            .on("mousemove vmousemove", function(e) {
              if (!dragging) {
                dragging = true;
                !window.requestAnimationFrame
                  ? setTimeout(function() {
                      animateDraggedHandle(
                        e,
                        xPosition,
                        dragWidth,
                        minLeft,
                        maxLeft,
                        containerOffset,
                        containerWidth,
                        resizeElement,
                        labelContainer,
                        labelResizeElement
                      );
                    }, 100)
                  : requestAnimationFrame(function() {
                      animateDraggedHandle(
                        e,
                        xPosition,
                        dragWidth,
                        minLeft,
                        maxLeft,
                        containerOffset,
                        containerWidth,
                        resizeElement,
                        labelContainer,
                        labelResizeElement
                      );
                    });
              }
            })
            .on("mouseup vmouseup", function(e) {
              dragElement.removeClass("draggable");
              resizeElement.removeClass("resizable");
            });
          e.preventDefault();
        })
        .on("mouseup vmouseup", function(e) {
          dragElement.removeClass("draggable");
          resizeElement.removeClass("resizable");
        });
    }

    function animateDraggedHandle(
      e,
      xPosition,
      dragWidth,
      minLeft,
      maxLeft,
      containerOffset,
      containerWidth,
      resizeElement,
      labelContainer,
      labelResizeElement
    ) {
      var leftValue = e.pageX + xPosition - dragWidth;
      //constrain the draggable element to move inside his container
      if (leftValue < minLeft) {
        leftValue = minLeft;
      } else if (leftValue > maxLeft) {
        leftValue = maxLeft;
      }

      var widthValue =
        ((leftValue + dragWidth / 2 - containerOffset) * 100) / containerWidth +
        "%";

      $(".draggable")
        .css("left", widthValue)
        .on("mouseup vmouseup", function() {
          $(this).removeClass("draggable");
          resizeElement.removeClass("resizable");
        });

      $(".resizable").css("width", widthValue);

      updateLabel(labelResizeElement, resizeElement, "left");
      updateLabel(labelContainer, resizeElement, "right");
      dragging = false;
    }

    function updateLabel(label, resizeElement, position) {
      if (position == "left") {
        label.offset().left + label.outerWidth() <
        resizeElement.offset().left + resizeElement.outerWidth()
          ? label.removeClass("is-hidden")
          : label.addClass("is-hidden");
      } else {
        label.offset().left >
        resizeElement.offset().left + resizeElement.outerWidth()
          ? label.removeClass("is-hidden")
          : label.addClass("is-hidden");
      }
    }
  });


  async function setLocation(theLocation) {
    let xhr     = new XMLHttpRequest();
    let result  = xhr.open("GET", `/set-location?location=${theLocation}`);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.onload  = (response) => {
        // Prevent returning to scroll position on reload.
        history.scrollRestoration = "manual";

        window.location.reload();
    };
    xhr.send();
  }
  function getLocation() {
    var name = "location=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }

    // Default
    return "UK";
  }

  $(function() {
    // Toggle dropdown visibility
    $('.selected-option').click(function() {
      $(this).parent().toggleClass('open');
    });

    // Set location when an option is clicked
    $('.dropdown-options a').click(function(e) {
      e.preventDefault();
      var selectedLocation = $(this).data('location');
      setLocation(selectedLocation);

      // Update the visible selected option text
      $('.selected-option').text($(this).text());

      // Close the dropdown
      $('.footer--locations').removeClass('open');
    });

    // Close dropdown if clicked outside
    $(document).click(function(e) {
      if (!$(e.target).closest('.footer--locations').length) {
        $('.footer--locations').removeClass('open');
      }
    });

    // Set initial location based on cookie
    var locationCookie = getLocation();
    if (locationCookie) {
      var locationText = $(".dropdown-options a[data-location='" + locationCookie + "']").text();
      $('.selected-option').text(locationText);
    }
  });

  function showFooterCta() {
    const cta = document.querySelector('.footer-cta');
    const height = document.documentElement.clientHeight;
    if(cta){
      if (document.documentElement.scrollTop > height / 4 ) {
        cta.classList.add('active');
      } else {
        cta.classList.remove('active');
      }
    }
  }

  window.addEventListener('scroll', showFooterCta);


  !function(a,b){var c=b(a,a.document,Date);a.lazySizes=c,"object"==typeof module&&module.exports&&(module.exports=c)}("undefined"!=typeof window?window:{},function(a,b,c){"use strict";var d,e;if(function(){var b,c={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:!0,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:!0,ricTimeout:0,throttleDelay:125};e=a.lazySizesConfig||a.lazysizesConfig||{};for(b in c)b in e||(e[b]=c[b])}(),!b||!b.getElementsByClassName)return{init:function(){},cfg:e,noSupport:!0};var f=b.documentElement,g=a.HTMLPictureElement,h="addEventListener",i="getAttribute",j=a[h].bind(a),k=a.setTimeout,l=a.requestAnimationFrame||k,m=a.requestIdleCallback,n=/^picture$/i,o=["load","error","lazyincluded","_lazyloaded"],p={},q=Array.prototype.forEach,r=function(a,b){return p[b]||(p[b]=new RegExp("(\\s|^)"+b+"(\\s|$)")),p[b].test(a[i]("class")||"")&&p[b]},s=function(a,b){r(a,b)||a.setAttribute("class",(a[i]("class")||"").trim()+" "+b)},t=function(a,b){var c;(c=r(a,b))&&a.setAttribute("class",(a[i]("class")||"").replace(c," "))},u=function(a,b,c){var d=c?h:"removeEventListener";c&&u(a,b),o.forEach(function(c){a[d](c,b)})},v=function(a,c,e,f,g){var h=b.createEvent("Event");return e||(e={}),e.instance=d,h.initEvent(c,!f,!g),h.detail=e,a.dispatchEvent(h),h},w=function(b,c){var d;!g&&(d=a.picturefill||e.pf)?(c&&c.src&&!b[i]("srcset")&&b.setAttribute("srcset",c.src),d({reevaluate:!0,elements:[b]})):c&&c.src&&(b.src=c.src)},x=function(a,b){return(getComputedStyle(a,null)||{})[b]},y=function(a,b,c){for(c=c||a.offsetWidth;c<e.minSize&&b&&!a._lazysizesWidth;)c=b.offsetWidth,b=b.parentNode;return c},z=function(){var a,c,d=[],e=[],f=d,g=function(){var b=f;for(f=d.length?e:d,a=!0,c=!1;b.length;)b.shift()();a=!1},h=function(d,e){a&&!e?d.apply(this,arguments):(f.push(d),c||(c=!0,(b.hidden?k:l)(g)))};return h._lsFlush=g,h}(),A=function(a,b){return b?function(){z(a)}:function(){var b=this,c=arguments;z(function(){a.apply(b,c)})}},B=function(a){var b,d=0,f=e.throttleDelay,g=e.ricTimeout,h=function(){b=!1,d=c.now(),a()},i=m&&g>49?function(){m(h,{timeout:g}),g!==e.ricTimeout&&(g=e.ricTimeout)}:A(function(){k(h)},!0);return function(a){var e;(a=!0===a)&&(g=33),b||(b=!0,e=f-(c.now()-d),e<0&&(e=0),a||e<9?i():k(i,e))}},C=function(a){var b,d,e=99,f=function(){b=null,a()},g=function(){var a=c.now()-d;a<e?k(g,e-a):(m||f)(f)};return function(){d=c.now(),b||(b=k(g,e))}},D=function(){var g,m,o,p,y,D,F,G,H,I,J,K,L=/^img$/i,M=/^iframe$/i,N="onscroll"in a&&!/(gle|ing)bot/.test(navigator.userAgent),O=0,P=0,Q=0,R=-1,S=function(a){Q--,(!a||Q<0||!a.target)&&(Q=0)},T=function(a){return null==K&&(K="hidden"==x(b.body,"visibility")),K||!("hidden"==x(a.parentNode,"visibility")&&"hidden"==x(a,"visibility"))},U=function(a,c){var d,e=a,g=T(a);for(G-=c,J+=c,H-=c,I+=c;g&&(e=e.offsetParent)&&e!=b.body&&e!=f;)(g=(x(e,"opacity")||1)>0)&&"visible"!=x(e,"overflow")&&(d=e.getBoundingClientRect(),g=I>d.left&&H<d.right&&J>d.top-1&&G<d.bottom+1);return g},V=function(){var a,c,h,j,k,l,n,o,q,r,s,t,u=d.elements;if((p=e.loadMode)&&Q<8&&(a=u.length)){for(c=0,R++;c<a;c++)if(u[c]&&!u[c]._lazyRace)if(!N||d.prematureUnveil&&d.prematureUnveil(u[c]))ba(u[c]);else if((o=u[c][i]("data-expand"))&&(l=1*o)||(l=P),r||(r=!e.expand||e.expand<1?f.clientHeight>500&&f.clientWidth>500?500:370:e.expand,d._defEx=r,s=r*e.expFactor,t=e.hFac,K=null,P<s&&Q<1&&R>2&&p>2&&!b.hidden?(P=s,R=0):P=p>1&&R>1&&Q<6?r:O),q!==l&&(D=innerWidth+l*t,F=innerHeight+l,n=-1*l,q=l),h=u[c].getBoundingClientRect(),(J=h.bottom)>=n&&(G=h.top)<=F&&(I=h.right)>=n*t&&(H=h.left)<=D&&(J||I||H||G)&&(e.loadHidden||T(u[c]))&&(m&&Q<3&&!o&&(p<3||R<4)||U(u[c],l))){if(ba(u[c]),k=!0,Q>9)break}else!k&&m&&!j&&Q<4&&R<4&&p>2&&(g[0]||e.preloadAfterLoad)&&(g[0]||!o&&(J||I||H||G||"auto"!=u[c][i](e.sizesAttr)))&&(j=g[0]||u[c]);j&&!k&&ba(j)}},W=B(V),X=function(a){var b=a.target;if(b._lazyCache)return void delete b._lazyCache;S(a),s(b,e.loadedClass),t(b,e.loadingClass),u(b,Z),v(b,"lazyloaded")},Y=A(X),Z=function(a){Y({target:a.target})},$=function(a,b){try{a.contentWindow.location.replace(b)}catch(c){a.src=b}},_=function(a){var b,c=a[i](e.srcsetAttr);(b=e.customMedia[a[i]("data-media")||a[i]("media")])&&a.setAttribute("media",b),c&&a.setAttribute("srcset",c)},aa=A(function(a,b,c,d,f){var g,h,j,l,m,p;(m=v(a,"lazybeforeunveil",b)).defaultPrevented||(d&&(c?s(a,e.autosizesClass):a.setAttribute("sizes",d)),h=a[i](e.srcsetAttr),g=a[i](e.srcAttr),f&&(j=a.parentNode,l=j&&n.test(j.nodeName||"")),p=b.firesLoad||"src"in a&&(h||g||l),m={target:a},s(a,e.loadingClass),p&&(clearTimeout(o),o=k(S,2500),u(a,Z,!0)),l&&q.call(j.getElementsByTagName("source"),_),h?a.setAttribute("srcset",h):g&&!l&&(M.test(a.nodeName)?$(a,g):a.src=g),f&&(h||l)&&w(a,{src:g})),a._lazyRace&&delete a._lazyRace,t(a,e.lazyClass),z(function(){var b=a.complete&&a.naturalWidth>1;p&&!b||(b&&s(a,"ls-is-cached"),X(m),a._lazyCache=!0,k(function(){"_lazyCache"in a&&delete a._lazyCache},9)),"lazy"==a.loading&&Q--},!0)}),ba=function(a){if(!a._lazyRace){var b,c=L.test(a.nodeName),d=c&&(a[i](e.sizesAttr)||a[i]("sizes")),f="auto"==d;(!f&&m||!c||!a[i]("src")&&!a.srcset||a.complete||r(a,e.errorClass)||!r(a,e.lazyClass))&&(b=v(a,"lazyunveilread").detail,f&&E.updateElem(a,!0,a.offsetWidth),a._lazyRace=!0,Q++,aa(a,b,f,d,c))}},ca=C(function(){e.loadMode=3,W()}),da=function(){3==e.loadMode&&(e.loadMode=2),ca()},ea=function(){if(!m){if(c.now()-y<999)return void k(ea,999);m=!0,e.loadMode=3,W(),j("scroll",da,!0)}};return{_:function(){y=c.now(),d.elements=b.getElementsByClassName(e.lazyClass),g=b.getElementsByClassName(e.lazyClass+" "+e.preloadClass),j("scroll",W,!0),j("resize",W,!0),j("pageshow",function(a){if(a.persisted){var c=b.querySelectorAll("."+e.loadingClass);c.length&&c.forEach&&l(function(){c.forEach(function(a){a.complete&&ba(a)})})}}),a.MutationObserver?new MutationObserver(W).observe(f,{childList:!0,subtree:!0,attributes:!0}):(f[h]("DOMNodeInserted",W,!0),f[h]("DOMAttrModified",W,!0),setInterval(W,999)),j("hashchange",W,!0),["focus","mouseover","click","load","transitionend","animationend"].forEach(function(a){b[h](a,W,!0)}),/d$|^c/.test(b.readyState)?ea():(j("load",ea),b[h]("DOMContentLoaded",W),k(ea,2e4)),d.elements.length?(V(),z._lsFlush()):W()},checkElems:W,unveil:ba,_aLSL:da}}(),E=function(){var a,c=A(function(a,b,c,d){var e,f,g;if(a._lazysizesWidth=d,d+="px",a.setAttribute("sizes",d),n.test(b.nodeName||""))for(e=b.getElementsByTagName("source"),f=0,g=e.length;f<g;f++)e[f].setAttribute("sizes",d);c.detail.dataAttr||w(a,c.detail)}),d=function(a,b,d){var e,f=a.parentNode;f&&(d=y(a,f,d),e=v(a,"lazybeforesizes",{width:d,dataAttr:!!b}),e.defaultPrevented||(d=e.detail.width)&&d!==a._lazysizesWidth&&c(a,f,e,d))},f=function(){var b,c=a.length;if(c)for(b=0;b<c;b++)d(a[b])},g=C(f);return{_:function(){a=b.getElementsByClassName(e.autosizesClass),j("resize",g)},checkElems:g,updateElem:d}}(),F=function(){!F.i&&b.getElementsByClassName&&(F.i=!0,E._(),D._())};return k(function(){e.init&&F()}),d={cfg:e,autoSizer:E,loader:D,init:F,uP:w,aC:s,rC:t,hC:r,fire:v,gW:y,rAF:z}});

  // Cookie Functions
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function eraseCookie(name) {
    document.cookie = name + "=; Max-Age=-99999999;";
  }

  // Alert Banner
  var alert_banner_cookie = getCookie("alert-banner-cookie");
  var alert_banner = document.getElementById("alert-banner");
  var close_alert_banner = document.getElementById("js-close-alert-banner");

  if (alert_banner_cookie) {
    // Do Nothing
  }
  else {
    $(".alert-banner").addClass("is-active");
  }
  if (close_alert_banner) {
    close_alert_banner.addEventListener("click", function() {
        alert_banner.classList.remove("is-active");
        document.body.classList.remove("alert-banner-showing");
        setCookie("alert-banner-cookie", "1", 365);
    });
  }



  document.addEventListener("DOMContentLoaded", function() {
      // Function to get the value of a query parameter
      function getQueryParam(param) {
          var searchParams = new URLSearchParams(window.location.search);
          return searchParams.get(param) || '';
      }

      // Function to set a cookie
      function setCookie(name, value, days) {
          var expires = "";
          if (days) {
              var date = new Date();
              date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
              expires = "; expires=" + date.toUTCString();
          }
          document.cookie = name + "=" + (value || "")  + expires + "; path=/";
      }

      // Capture UTM parameters and set them as cookies
      var utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
      utmParams.forEach(function(param) {
          var value = getQueryParam(param);
          if (value) {
              setCookie(param, value, 30); // Set cookies for 30 days
          }
      });
  });

  // Smooth Scrolling

  $(document).ready(function() {
      // Function to determine the offset based on device width
      function getOffset() {
          const width = $(window).width();
          if (width < 1440) {
              return 93; // Offset for mobile
          } 
      else {
              return 151; // Offset for desktop
          }
      }

      // Smooth scroll to the target element
      $('.scroll-link').on('click', function(e) {
          e.preventDefault(); // Prevent default anchor click behavior
          const target = $(this).attr('href');
          const offset = getOffset();
          const targetPosition = $(target).offset().top - offset;

          $('html, body').animate({
              scrollTop: targetPosition
          }, 600); // Adjust the duration as needed
      });

      // Handle window resizing
      $(window).on('resize', function() {
          // Re-bind the click event to ensure the correct offset is used
          $('.scroll-link').off('click').on('click', function(e) {
              e.preventDefault();
              const target = $(this).attr('href');
              const offset = getOffset();
              const targetPosition = $(target).offset().top - offset;

              $('html, body').animate({
                  scrollTop: targetPosition
              }, 600);
          });
      });
  });
};

export { runLegacyApp };